/* eslint-disable */
import ctype from 'component-type';

const expected = `function`;

/**
 * Check whether or not a given `item` is a Function
 * @param {any} item The `item` to check
 * @returns {boolean} Wheter or not the `item` is a indeed a Function
 */
const isFunction = (item) => ctype(item) === expected;

export default isFunction;
